<template>
    <sa-page-layout :data="gruppo" :pathResource="pathResource" :btnBackVisible="true" :btnSaveVisible="true" :titolo="gruppo.nome" :linkback="linkback" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-row>
                <b-col cols="12" sm="6">
                    <b-form-input v-model="gruppo.nome" placeholder="Nome"></b-form-input>
                </b-col>
                <b-col cols="12" sm="6">
                    <b-form-input v-model="gruppo.descrizione" placeholder="Descrizione"></b-form-input>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <b-tabs content-class="mt-3" class="sa-tab" style="height: 100%" fill>
                <b-tab title="Menu" active>
                    <div class="b-table-sticky-header">
                        <b-table striped hover :items="gruppo.menu" :fields="fieldsMenu" head-variant="light" sort-icon-left>
                            <template v-slot:cell(iconCls)="{ item }">
                                <i :class="'fas fa-' + item.iconCls"></i>
                                <!-- You can also use the font-awesome-icon component here -->
                            </template>
                            <template v-slot:cell(text)="{ item }">
                                <div>
                                    <span class="sa-text-bold">{{ item.text }} ({{ item.routeId }})</span>
                                </div>
                                <div>
                                    <span>{{ item.view }}</span>
                                </div>
                            </template>
                            <template v-slot:cell(selected)="{ item }">
                                <b-form-checkbox v-model="item.selezionato" name="check-button" switch size="lg"></b-form-checkbox>
                            </template>
                        </b-table>
                    </div>
                </b-tab>
                <b-tab title="Permessi">
                    <div class="b-table-sticky-header">
                        <b-table striped hover :filter="filter" :filterIncludedFields="filterOn" :items="gruppo.sezioni" :fields="fieldsSezioni" head-variant="light" sort-icon-left>
                            <template v-slot:cell(permessiSezione)="{ item }">
                                <div></div>
                                <!--<b-form-checkbox v-for="permesso in verificaPermessoSezione(item.permessiSezione, permessi)" :key="permesso.valore" switch size="lg" class="sa-normal-label">-->
                                <div v-for="(permesso, index) in item.permessi" :key="index">
                                    <b-form-checkbox v-model="permesso.attivo" size="md" switch class="sa-normal-label">{{ permesso.descrizione }}</b-form-checkbox>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </b-tab>
            </b-tabs>
        </template>
    </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
//import { SaModalLoading } from "../../../components/modal";
export default {
    components: { SaPageLayout },
    label: "Dettagllio Gruppo s",
    data() {
        return {
            linkback: "/gruppi",
            pathResource: "/gruppi",
            linkedit: "",
            showModalLoading: false,
            idGruppo: String,
            gruppo: { nome: "", descrizioneGruppo: "", menu: [], sezioni: [] },
            label: "Dettagllio Gruppo",
            filter: null,
            filterOn: [],
            fieldsMenu: [
                {
                    label: "",
                    key: "iconCls",
                    sortable: false,
                    class: "sa-col-icon",
                },
                {
                    label: "Menu",
                    key: "text",
                    sortable: false,
                },
                {
                    label: "Padre",
                    key: "idPadre",
                    sortable: false,
                },
                {
                    key: "selected",
                    label: "",
                    sortable: false,
                    class: "sa-width-2 sa-td-vertical-middle",
                },
            ],
            fieldsSezioni: [
                {
                    label: "Sezione",
                    key: "descrizione",
                    sortable: true,
                },
                {
                    label: "Permessi",
                    key: "permessiSezione",
                    sortable: false,
                    class: "sa-width-12",
                },
            ],
        };
    },
    mounted: function () {
        let me = this;
        me.id = this.$route.params.id;
        if (me.id !== "-1") {
            me.linkback = me.linkback + "/view/" + me.id;
        }
        me.loadData();
    },
    methods: {
        verificaPermessoSezione(permesso) {
            return permesso ? "checked" : "unchecked";
        },
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + "/vocimenu";
            axios.get(link).then((response) => {
                me.menu = response.data.data;
                link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                axios.get(link + me.id).then((response) => {
                    me.gruppo = response.data.data;
                    me.showModalLoading = false;
                });
            });
        },
        onBack() {
            let me = this;
            if (me.gruppo.id) {
                me.$router.replace("/gruppi/view/" + me.gruppo.id).catch((err) => {
                    err;
                });
            } else {
                me.$router.replace("/gruppi").catch((err) => {
                    err;
                });
            }
        },
    },
};
</script>
<style>
.sa-text-right {
    text-align: right;
}
@media only screen and (max-width: 767px) {
    .sa-text-right {
        text-align: left;
    }
}
.card {
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.125), 0 1px 3px rgba(0, 0, 0, 0.2);
    margin-bottom: 1rem;
}
</style>
